/**
 * @file
 * Provides a component to render the columns of a multi column paragraph.
 */

import React from 'react';
import { useIntl } from 'react-intl';
import Link from '~/jobiqo/components/Link';
import AdUnitColumnSlot from '~/jobiqo/components/Slots/AdUnitColumnSlot';
import Image from '~/jobiqo/components/Image';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import { ImageText } from '~/vcl/organisms/04-landingpage/07-imagetext';
import { LinksBlock } from '~/vcl/molecules/04-navigation/03-links-block';
import Spacing from '~/vcl/atoms/06-layout/07-spacing';
import { getFormattedPageLink } from '~/jobiqo/utils/routes';
import LinkButton from '~/vcl/atoms/01-forms/01-button/02-link-button';
import NextLink from 'next/link';

export const Column = ({ column }) => {
  const intl = useIntl();
  switch (column?.bundle) {
    case 'column_text':
      return (
        <WYSIWYGText
          format="full_html"
          content={column?.columnText ? column?.columnText : ''}
        />
      );
    // We dont know dimensions so we can't use the optimized image component.
    case 'text_with_image_on_top':
      return (
        <ImageText
          image={
            <Image
              src={column.multiColImage.url}
              alt={column.multiColImage.alt}
              width={column.multiColImage.width}
              height={column.multiColImage.height}
              caption={column.multiColImage.caption}
            />
          }
        >
          <WYSIWYGText
            format="full_html"
            content={column?.multiColText ? column?.multiColText : ''}
          />
          {column.button ? (
            <Spacing marginTop={7}>
              <Link asChild prefetch={false}>
                <LinkButton
                  linkElement={NextLink}
                  {...getFormattedPageLink(column.button?.url)}
                  buttonStyle="primary"
                >
                  {column.button?.text}
                </LinkButton>
              </Link>
            </Spacing>
          ) : null}
        </ImageText>
      );
    case 'facet_block':
      const items = column?.facet?.values?.map((facet) => (
        <Link
          data-test-id={`facet-link-${column?.facet.name}`}
          key={facet.filter}
          href={`/jobs/${facet.alias}`}
        >
          {`${facet.label} (${facet.totalCount})`}
        </Link>
      ));

      return items?.length > 0 ? (
        <LinksBlock
          title={column.title}
          maxItems={column.maxItems}
          links={items}
          expandText={intl.formatMessage({
            id: 'facet_block_expand',
            defaultMessage: 'more',
          })}
          collapseText={intl.formatMessage({
            id: 'facet_block_collapse',
            defaultMessage: 'less',
          })}
        />
      ) : null;
    case 'row_ad_unit':
      return (
        <AdUnitColumnSlot bundle={column.bundle} adUnitId={column.adUnitId} />
      );
    default:
      return null;
  }
};
export default Column;
